@if (loading()) {
  <div class="flex justify-center py-12">
    <app-loading />
  </div>
} @else if (error()) {
  <app-error [apiError]="error()" />
} @else {
  <div class="flex flex-col gap-6">
    <app-view-details [title]="pharmacyInfoTitle" [fields]="pharmacyInfoFields()" />

    <app-view-details [title]="representativeTitle" [fields]="representativeFields()" />

    <app-view-details [title]="pharmacyAddressTitle" [fields]="addressFields()" />

    <app-view-details [title]="pharmacyClassificationTitle" [fields]="categoryFields()" />

    <div
      class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
      <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
        <h2 class="title text-[18px] font-bold" i18n="@@uploadedDocuments">Uploaded Documents</h2>
      </div>

      <app-user-view-file-image-details [files]="documentsList()" [twoColumns]="true" />
    </div>
  </div>
}
